<mat-nav-list>
  <a *ngFor="let item of (menu$ | async)" mat-list-item routerLink="{{item.route}}" (click)="onSidenavClose()">
    <mat-icon>{{item.icon}}</mat-icon><span class="nav-caption">{{item.label | translate}}</span>
  </a>
</mat-nav-list>